<script lang="ts" setup>
import {useI18n} from 'vue-i18n';

const {t} = useI18n();
</script>

<template>
  <q-page padding>
    <div class="row justify-center">
      <zbm-box class="col-auto text-center"
               :box-bkgd-color="$zb.enums.BoxBackgroundColorEnum.linearGradient"
               :box-border-radius="$zb.enums.BoxBorderRadiusEnum.lg"
               :box-drop-shadow="$zb.enums.BoxDropShadowEnum.xl"
               :box-width="$zb.enums.BoxWidthEnum.xs">
        <q-icon color="white"
                name="fa-regular fa-triangle-person-digging"
                size="92px" />
        <p>{{ t('error_outage_try_later') }}</p>
      </zbm-box>
    </div>
  </q-page>
</template>

<style lang="scss" scoped>
.box {
  color: $white;
  padding-block: 75px 100px;
  padding-inline: 50px;
  
  .q-icon {
    margin-block-end: 34px;
  }
}
</style>